/* @HEADER
 * @version 1.1.298 | 2026-10-18
 * @purpose What the recorder is told when the board on screen changes (ZVX-DEV-7676): the kind of the space entered — an ordinary one, the inbox, or one of the system summaries — as a closed name, never an id or a name.
 * @sidecar boardChangeDecisions.mjs.header.md
 * @layer app | @hex domain | @ctx navigation
 * @public false
 * @edit careful
 */

// SpecRefs: ZVX-DEV-7676, ZVX-DEV-6430

import {
  DEFAULT_BOARD_GROUP_ID,
  isAllProjectsSpace,
  isAllTasksSpace,
  isOrgTasksSpace,
} from '@modules/board/public-api.mjs';

/**
 * `aggregate` — «Все проекты», «Все задачи организации», «Все задачи проекта»; `inbox` — the catch-all space
 * «Входящие»; `ordinary` — every other space, and any id the host cannot find a record for.
 *
 * @param {{ id?: string, system_kind?: string } | null | undefined} group
 * @returns {'ordinary' | 'inbox' | 'aggregate'}
 */
export function boardKindOf(group) {
  if (isAllProjectsSpace(group) || isAllTasksSpace(group) || isOrgTasksSpace(group))
    return 'aggregate';
  if (group?.id === DEFAULT_BOARD_GROUP_ID) return 'inbox';
  return 'ordinary';
}
